module.exports = __webpack_public_path__ + "img/foward.845b375.png";